import { render, staticRenderFns } from "./dropdown_value.vue?vue&type=template&id=1831fb6d"
import script from "./dropdown_value.vue?vue&type=script&lang=js"
export * from "./dropdown_value.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports